module.exports = __webpack_public_path__ + "img/icon_2_34.f3db3735.png";